import React from 'react';
import { Spotlight } from './Spotlight';
import { Microscope, Leaf, Droplet, Sparkles, Clock } from 'lucide-react';
export const Solution = () => {
  const differentiators = [{
    icon: <Microscope className="w-6 h-6 metallic-gold-icon" data-id="element-500" />,
    title: 'Penetra la fibra capilar',
    desc: 'No solo la superficie, sino el interior de cada hebra.'
  }, {
    icon: <Leaf className="w-6 h-6 metallic-gold-icon" data-id="element-501" />,
    title: 'Sin formol ni químicos',
    desc: 'Apto para cabellos teñidos, decolorados, embarazadas y niñas.'
  }, {
    icon: <Droplet className="w-6 h-6 metallic-gold-icon" data-id="element-502" />,
    title: 'Hidratación profunda',
    desc: 'Aporta y retiene la humedad natural de tu cabello.'
  }, {
    icon: <Sparkles className="w-6 h-6 metallic-gold-icon" data-id="element-503" />,
    title: 'Sella la cutícula',
    desc: 'Elimina el frizz sin crear dependencia química.'
  }, {
    icon: <Clock className="w-6 h-6 metallic-gold-icon" data-id="element-504" />,
    title: 'Resultados que duran',
    desc: 'De 3 a 8 meses, y con el cuidado adecuado, hasta 10 meses.'
  }];
  return <section id="solucion" className="py-16 relative overflow-hidden" style={{
    background: 'linear-gradient(to bottom, #FAF5EA 0%, #FAF5EA 4%, #F6ECDD 18%, #F2E5D5 38%, #F2E5D5 62%, #F6ECDD 82%, #FAF5EA 96%, #FAF5EA 100%)'
  }} data-id="element-505">
      <Spotlight className="opacity-70" data-id="element-506" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-507">
        <div className="text-center mb-16" data-id="element-508">
          <h2 className="text-3xl md:text-5xl font-serif text-neutral-900 mb-6" data-id="element-509">
            La Transformación{' '}
            <span className="metallic-gold-text italic" data-id="element-510">Nano-Orgánica</span>
          </h2>
          <p className="text-lg text-neutral-600 max-w-3xl mx-auto font-light" data-id="element-511">
            El verdadero problema no es tu cabello. Es que has estado usando
            soluciones que atacan tu cabello en lugar de repararlo.
          </p>
        </div>

        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-xl shadow-gold-900/5 border border-gold-100 mb-16" data-id="element-512">
          <p className="text-xl md:text-2xl text-center text-neutral-800 font-serif leading-relaxed max-w-4xl mx-auto" data-id="element-513">
            La Nanotecnología Orgánica penetra la fibra capilar desde adentro —
            no la aplana por fuera como los químicos agresivos, sino que{' '}
            <span className="text-gold-600 font-medium" data-id="element-514">
              reconstruye, nutre y sella cada hebra
            </span>{' '}
            con ingredientes naturales libres de formol.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center" data-id="element-515">
          {differentiators.map((item, index) => <div key={index} className={`bg-beige-50 rounded-3xl p-8 border border-beige-200 hover:border-gold-300 transition-colors group ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-516">
              <div className="w-14 h-14 bg-gold-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-517">
                {item.icon}
              </div>
              <h3 className="text-xl font-medium text-neutral-900 mb-3" data-id="element-518">
                {item.title}
              </h3>
              <p className="text-neutral-600" data-id="element-519">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
};